class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.read-more-content');
    this.labels = this.querySelectorAll('.read-more-label');
    this.button = this.querySelector('.button');
    this.lines = this.dataset.lines || 5;

    if (!this.content || !this.button) return;
    this.initReadMore();
  }

  initReadMore() {
    console.log('init read more');
    const contentHeight = this.content.getBoundingClientRect().height;
    const contentEl = this.content.querySelector('p') || this.content;
    const lineHeight = parseFloat(window.getComputedStyle(contentEl).lineHeight);
    const readMoreHeight = lineHeight * this.lines;

    if (contentHeight > readMoreHeight) {
      this.button.classList.remove('hidden');
      this.content.style.height = `${readMoreHeight}px`;

      this.button.addEventListener('click', event => {
        this.toggleContent();
      });
    }
  }

  toggleContent() {
    this.content.classList.toggle('expanded');
    this.labels.forEach(label => label.classList.toggle('hidden'));
  }
}

customElements.define('read-more', ReadMore);
